import React from 'react';
import { Avatar, mergeClasses } from '@fluentui/react-components';
import { useUserAvatarStyles } from './EnhancedAvatar.styles';

interface UserAvatarProps extends React.ComponentProps<typeof Avatar> {
  className?: string
  fontSize?: 'default' | 'small' | 'medium' | 'large'
}

const EnhancedAvatar: React.FC<UserAvatarProps> = ({
  name,
  fontSize = 'default',
  size = 96,
  className,
  ...restProps
}) => {
  const styles = useUserAvatarStyles();
  const avatarClass = mergeClasses(
    'enhanced-user-avatar',
    fontSize !== 'default' && styles[fontSize],
    styles.base,
    className,
  );

  return <Avatar className={avatarClass} name={name} size={size} {...restProps} />;
};

export default EnhancedAvatar;
